import dataset from './cluster-evidence.json'
import type { HighlightRange } from '@/app/thermage/_data/highlights'

export const activeEvidenceTopics = ['effect', 'price', 'pain', 'recovery'] as const
export type UltheraEvidenceTopic = typeof activeEvidenceTopics[number]
export const ultheraEvidenceAudit = { checkedAt: dataset.checkedAt, ...dataset.stats }

export function getUltheraClusterReviews(topic: UltheraEvidenceTopic) {
  return dataset.reviews.filter(review => review.sections.some(slot => slot.startsWith(`${topic}-`)))
    .map(review => ({
      ...review,
      highlights: review.highlights as Partial<Record<string, HighlightRange[]>>,
      sections: review.sections.filter(slot => slot.startsWith(`${topic}-`)),
    }))
}
export type UltheraClusterReview = ReturnType<typeof getUltheraClusterReviews>[number]

/** Compatibility for article imports; all public review text comes from the same masked snapshot. */
export function getUltheraEvidenceReviews(topic: UltheraEvidenceTopic) {
  return getUltheraClusterReviews(topic).map(review => ({
    sourceId: review.sourceId,
    source: review.source as '네이버' | '구글' | '카카오' | '모두닥',
    date: review.date.replaceAll('-', '.'), text: review.text,
    tags: review.sections.map(slot => `${slot.slice(-2)}절 근거`),
  }))
}
